"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPredicateExecutionError = exports.createTimeoutError = exports.defaultTimeoutErrorMessage = void 0;
exports.defaultTimeoutErrorMessage = `[waitForCondition] Timeout exceeded while waiting for the condition to become true`;
const createTimeoutError = (predicate, customErrorMessage) => {
    let message = customErrorMessage;
    if (!message) {
        message = exports.defaultTimeoutErrorMessage;
        if (process.env.NODE_ENV === 'test') {
            message += `:\npredicate function: ${predicate.toString()}`;
        }
    }
    return new Error(message);
};
exports.createTimeoutError = createTimeoutError;
const createPredicateExecutionError = (error) => {
    error.message = `[waitForCondition] Predicate threw an error: ${error.message}`;
    return error;
};
exports.createPredicateExecutionError = createPredicateExecutionError;
//# sourceMappingURL=errors.js.map